import React, { Component } from "react";

import FormItemsInlineGroup from "../../../shared/items/static/formItemsInlineGroup";
import FormItemsInline from "../../../shared/items/static/formItemsInline";
import FormItem from "../../../shared/items/static/formItem";
import InputDate from "../../../shared/items/contols/inputDate";
import InputTime from "../../../shared/items/contols/inputTime";
import { withSelectedReports } from "../../../shared/containers/containerSelectedReports";
import { withReportTime } from "../../../shared/containers/containerReportTime";

class TimeRangeReport extends Component {
  componentDidUpdate(prevPeops) {
    const { selectedReports, reportEndDate, reportStartDate, onChangeTimeReport } = this.props;

    const isDayInterval = selectedReports.length > 0 && selectedReports[0].requestInerval === 1;

    if (isDayInterval) {
      const start = {
        day: reportStartDate.getDate(),
        month: reportStartDate.getMonth(),
        year: reportStartDate.getYear(),
      };

      const end = {
        day: reportEndDate.getDate(),
        month: reportEndDate.getMonth(),
        year: reportEndDate.getYear(),
      };

      if (start.day === end.day && start.month === end.month && start.year === end.year) {
        onChangeTimeReport("reportEndDate", new Date(reportEndDate.setDate(reportEndDate.getDate() + 1)));
      }
    }
  }

  render() {
    const { onHandleChangeStore, valueStore, selectedReports } = this.props;
    const isDayInterval = selectedReports.length > 0 && selectedReports[0].requestInerval === 1;

    return (
      <FormItemsInlineGroup>
        <FormItemsInline>
          <FormItem title="Начальная Дата">
            <InputDate
              name="reportStartDate"
              onHandleChangeStore={onHandleChangeStore.bind(this, "reportStartDate")}
              valueStore={valueStore}
              maxDate={new Date()}
            />
          </FormItem>

          {isDayInterval ? null : (
            <FormItem title="Начальное Время">
              <InputTime
                name="reportStartTime"
                onHandleChangeStore={onHandleChangeStore.bind(this, "reportStartTime")}
                valueStore={valueStore}
              />
            </FormItem>
          )}
        </FormItemsInline>

        <FormItemsInline>
          <FormItem title="Конечная Дата">
            <InputDate
              name="reportEndDate"
              onHandleChangeStore={onHandleChangeStore.bind(this, "reportEndDate")}
              valueStore={valueStore}
              minDate={valueStore.reportStartDate}
            />
          </FormItem>

          {isDayInterval ? null : (
            <FormItem title="Конечное Время">
              <InputTime
                name="reportEndTime"
                onHandleChangeStore={onHandleChangeStore.bind(this, "reportEndTime")}
                valueStore={valueStore}
              />
            </FormItem>
          )}
        </FormItemsInline>
      </FormItemsInlineGroup>
    );
  }
}

export default withReportTime(withSelectedReports(React.memo(TimeRangeReport)));
